(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Sprint', Sprint);

    Sprint.$inject = ['$resource', 'DateUtils'];

    function Sprint($resource, DateUtils) {
        var resourceUrl = 'api/sprints/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.inicio = DateUtils.convertLocalDateFromServer(data.inicio);
                        data.fim = DateUtils.convertLocalDateFromServer(data.fim);
                    }
                    return data;
                }
            },
            'getBySituacao': {
                url: '/api/sprint-by-situacao/:situacao',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.inicio = DateUtils.convertLocalDateFromServer(data.inicio);
                        data.fim = DateUtils.convertLocalDateFromServer(data.fim);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.inicio = DateUtils.convertLocalDateToServer(copy.inicio);
                    copy.fim = DateUtils.convertLocalDateToServer(copy.fim);
                    return angular.toJson(copy);
                }
            },
            'encerrar': {
                method: 'PUT',
                url: '/api/sprints-encerramento',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.inicio = DateUtils.convertLocalDateToServer(copy.inicio);
                    copy.fim = DateUtils.convertLocalDateToServer(copy.fim);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.inicio = DateUtils.convertLocalDateToServer(copy.inicio);
                    copy.fim = DateUtils.convertLocalDateToServer(copy.fim);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
